export const EXAM_CONFIG = {
  math: {
    label: 'Mathematical Reasoning',
    icon: 'calculate',
    color: '#6366f1',
    description: 'Algebra, geometry, numbers & data analysis',
  },
  science: {
    label: 'Science',
    icon: 'science',
    color: '#0ea5e9',
    description: 'Life science, physical science & Earth science',
  },
  'language-arts': {
    label: 'Reasoning Through Language Arts',
    icon: 'menu_book',
    color: '#10b981',
    description: 'Reading comprehension, writing & language',
  },
  'social-studies': {
    label: 'Social Studies',
    icon: 'public',
    color: '#f59e0b',
    description: 'Civics, US history, geography & economics',
  },
};

export const EXAM_SUBJECT_IDS = Object.keys(EXAM_CONFIG);
